import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-key-dates',
    templateUrl: './key-dates.component.html',
    styleUrls: ['./key-dates.component.css'],
    standalone: false
})
export class KeyDatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
